import { useSelector } from "react-redux";
export function useLoading() {
  const context = useSelector((state) => state.globalLoader.value);
  return context;
}
